import React from 'react';
import { Box, Grid } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { FormAccordionItemList } from 'src/UI/dynamicUI/layout/DynamicEntitySection';
import { FinancialFormField } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormField';
import { GridPair } from 'src/financial/financial-data/financial-item/forms/common/GridPair';
import { FormValuesType } from 'src/UI/dynamicUI/types';
import { PercentageOrPoundField } from 'src/financial/financial-data/financial-item/forms/common/PercentageOrPoundField';

type FeeFormAccordionItemListProps = {
  isEditing: boolean;
  form: UseFormReturnType<FormValuesType>;
};

export const FEE = 'MortgageFee';

export const MortgageFeeFormAccordionItemList = ({
  form,
  isEditing,
}: FeeFormAccordionItemListProps) => {
  const untypedItems = form.getValues()[FEE];
  const fees = Array.isArray(untypedItems) ? untypedItems : [];

  const handleAddFee = () => {
    form.insertListItem(FEE, {
      id: null,
      fee_type: null,
      amount_type: 'CURRENCY_AMOUNT',
      amount: null,
      payment_source: null,
      trigger: null,
      amount_received: null,
      amount_received_date: null,
    });
  };

  return (
    <FormAccordionItemList
      value="fee"
      label="Fees"
      counterLabel="Fees"
      button={{
        label: 'Add fee',
        onClick: handleAddFee,
      }}
      isEditing={isEditing}
      form={form}
      entityType={FEE}
    >
      {fees.map((_, index) => (
        <Box key={index}>
          <Grid>
            <GridPair
              first={<FinancialFormField field="fee_type" index={index} product={FEE} />}
              second={
                <PercentageOrPoundField
                  form={form}
                  formFieldName="amount"
                  percentageOrPoundFieldName="amount_type"
                  index={index}
                  product={FEE}
                />
              }
            />
            <GridPair
              first={<FinancialFormField field="trigger" index={index} product={FEE} />}
              second={<FinancialFormField field="payment_source" index={index} product={FEE} />}
            />
            <GridPair
              isHighlighted
              first={<FinancialFormField field="amount_received" index={index} product={FEE} />}
              second={
                <FinancialFormField field="amount_received_date" index={index} product={FEE} />
              }
            />
          </Grid>
        </Box>
      ))}
    </FormAccordionItemList>
  );
};
